"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSFilterState = void 0;
var SfilterTypeGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup.init");
var SfilterKeywordGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterKeywordGroup.init");
var SfilterDistrictGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterDistrictGroup.init");
var SfilterPriceGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup.init");
var SfilterSizeGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterSizeGroup.init");
var SfilterBedGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterBedGroup.init");
var SfilterAmenityGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterAmenityGroup.init");
var SfilterSortGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterSortGroup.init");
var SfilterConfirmGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterConfirmGroup.init");
var SfilterLayoutGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterLayoutGroup.init");
var SfilterShowOnlyGroup_init_1 = require("@/pages/common/states/sfilter/sections/SfilterShowOnlyGroup.init");
exports.defaultSFilterState = {
    type: SfilterTypeGroup_init_1.defaultSfilterTypeGroupState,
    keyword: SfilterKeywordGroup_init_1.defaultSfilterKeywordGroupState,
    layout: SfilterLayoutGroup_init_1.defaultSfilterLayoutGroupState,
    district: SfilterDistrictGroup_init_1.defaultSfilterDistrictGroupState,
    price: SfilterPriceGroup_init_1.defaultSfilterPriceGroupState,
    size: SfilterSizeGroup_init_1.defaultSfilterSizeGroupState,
    bed: SfilterBedGroup_init_1.defaultSfilterBedGroupState,
    amenity: SfilterAmenityGroup_init_1.defaultSfilterAmenityGroupState,
    sort: SfilterSortGroup_init_1.defaultSfilterSortGroup,
    confirm: SfilterConfirmGroup_init_1.defaultSfilterConfirmGroupState,
    hasUpdated: false,
    showOnly: SfilterShowOnlyGroup_init_1.defaultSfilterShowOnlyGroupState,
};
